document.documentElement.classList.remove('no-js');

const formatMoney = (cents, format = '${{amount}}') => {
  const value = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(cents || 0) / 100);
  return format.replace('{{amount}}', value).replace('{{amount_no_decimals}}', value);
};

const rememberPopup = (modal) => {
  const days = Number(modal.dataset.frequencyDays || 1);
  try { localStorage.setItem(modal.dataset.popupKey, String(Date.now() + days * 86400000)); } catch (_) {}
};

const canShowPopup = (modal) => {
  try { return Number(localStorage.getItem(modal.dataset.popupKey) || 0) < Date.now(); } catch (_) { return true; }
};

document.addEventListener('click', (event) => {
  const menuToggle = event.target.closest('[data-menu-toggle]');
  if (menuToggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    const opening = menu?.hidden;
    if (menu) menu.hidden = !opening;
    document.querySelectorAll('[data-menu-toggle]').forEach((button) => button.setAttribute('aria-expanded', String(opening)));
    document.body.classList.toggle('menu-open', Boolean(opening));
  }

  const modalOpen = event.target.closest('[data-open-modal]');
  if (modalOpen) {
    const modal = document.getElementById(modalOpen.dataset.openModal);
    if (modal) {
      modal.hidden = false;
      document.body.classList.add('modal-open');
      modal.querySelector('input,button,textarea')?.focus();
    }
  }

  const modalClose = event.target.closest('[data-close-modal]');
  if (modalClose || event.target.matches('.kv-modal')) {
    const modal = event.target.closest('.kv-modal');
    if (modal) {
      modal.hidden = true;
      document.body.classList.remove('modal-open');
      if (modal.dataset.popupKey) rememberPopup(modal);
    }
  }

  const mobileAdd = event.target.closest('[data-mobile-add]');
  if (mobileAdd) document.querySelector('[data-product-form]')?.requestSubmit();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const modal = document.querySelector('.kv-modal:not([hidden])');
    if (modal) {
      modal.hidden = true;
      document.body.classList.remove('modal-open');
      if (modal.dataset.popupKey) rememberPopup(modal);
    }
  }
});

document.querySelectorAll('[data-product-root]').forEach((root) => {
  const form = root.querySelector('[data-product-form]');
  const idInput = form?.querySelector('input[name="id"]');
  const price = root.querySelector('[data-product-price]');
  const mobilePrice = root.querySelector('[data-mobile-price]');
  const compare = root.querySelector('[data-compare-price]');
  const priceBadge = root.querySelector('[data-price-badge]');
  const add = root.querySelector('[data-add-to-cart]');
  const mobileAdd = root.querySelector('[data-mobile-add]');
  const selectedWeights = root.querySelectorAll('[data-selected-weight]');
  const selectedSkus = root.querySelectorAll('[data-selected-sku]');
  const selectedLengths = root.querySelectorAll('[data-selected-length]');
  const format = root.dataset.moneyFormat || '${{amount}}';

  root.querySelectorAll('[data-variant-card]').forEach((card) => {
    card.addEventListener('click', () => {
      if (card.disabled) return;
      root.querySelectorAll('[data-variant-card]').forEach((item) => {
        item.classList.remove('is-selected');
        item.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('is-selected');
      card.setAttribute('aria-pressed', 'true');
      if (idInput) idInput.value = card.dataset.variantId;
      const newPrice = formatMoney(card.dataset.price, format);
      if (price) price.textContent = newPrice;
      if (mobilePrice) mobilePrice.textContent = newPrice;
      if (compare) {
        compare.textContent = card.dataset.comparePrice ? formatMoney(card.dataset.comparePrice, format) : '';
        compare.hidden = !card.dataset.comparePrice;
      }
      if (priceBadge) priceBadge.hidden = !card.dataset.comparePrice;
      selectedWeights.forEach((item) => { item.textContent = card.dataset.weight || 'See selected option'; });
      selectedSkus.forEach((item) => { item.textContent = card.dataset.sku || '—'; });
      selectedLengths.forEach((item) => { item.textContent = card.dataset.length || card.dataset.title; });
      const available = card.dataset.available === 'true';
      if (add) {
        add.disabled = !available;
        add.querySelector('span').textContent = available ? 'Add to cart' : 'Sold out';
      }
      if (mobileAdd) {
        mobileAdd.disabled = !available;
        mobileAdd.textContent = available ? 'Add to cart' : 'Sold out';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', card.dataset.variantId);
      window.history.replaceState({}, '', url);
    });
  });

  const lightbox = root.querySelector('[data-product-lightbox]');
  const galleryImages = [...root.querySelectorAll('[data-gallery-open]')];
  if (lightbox && galleryImages.length) {
    const lightboxImage = lightbox.querySelector('[data-lightbox-image]');
    const lightboxCounter = lightbox.querySelector('[data-lightbox-counter]');
    const previousButton = lightbox.querySelector('[data-lightbox-previous]');
    const nextButton = lightbox.querySelector('[data-lightbox-next]');
    let activeImage = 0;
    let returnFocus = null;

    const showImage = (index) => {
      activeImage = (index + galleryImages.length) % galleryImages.length;
      const trigger = galleryImages[activeImage];
      lightboxImage.removeAttribute('srcset');
      lightboxImage.removeAttribute('sizes');
      lightboxImage.src = trigger.dataset.gallerySrc;
      lightboxImage.alt = trigger.dataset.galleryAlt || '';
      lightboxCounter.textContent = `${activeImage + 1} / ${galleryImages.length}`;
    };

    galleryImages.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        returnFocus = trigger;
        showImage(index);
        lightbox.showModal();
      });
    });

    previousButton.addEventListener('click', () => showImage(activeImage - 1));
    nextButton.addEventListener('click', () => showImage(activeImage + 1));
    lightbox.querySelector('[data-lightbox-close]').addEventListener('click', () => lightbox.close());
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });
    lightbox.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showImage(activeImage - 1);
      if (event.key === 'ArrowRight') showImage(activeImage + 1);
    });
    lightbox.addEventListener('close', () => returnFocus?.focus());

    const hasMultipleImages = galleryImages.length > 1;
    previousButton.hidden = !hasMultipleImages;
    nextButton.hidden = !hasMultipleImages;
  }
});

const popupQueue = [];
let popupActive = false;
const runPopupQueue = () => {
  if (popupActive || !popupQueue.length) return;
  const modal = popupQueue.shift();
  if (!canShowPopup(modal)) return runPopupQueue();
  popupActive = true;
  modal.hidden = false;
  document.body.classList.add('modal-open');
  const observer = new MutationObserver(() => {
    if (modal.hidden) {
      observer.disconnect();
      popupActive = false;
      setTimeout(runPopupQueue, 350);
    }
  });
  observer.observe(modal, { attributes: true, attributeFilter: ['hidden'] });
};

document.querySelectorAll('[data-email-popup]').forEach((modal) => {
  modal.querySelector('form')?.addEventListener('submit', () => rememberPopup(modal));
  const delay = Math.max(0, Number(modal.dataset.delay || 0)) * 1000;
  setTimeout(() => {
    if (canShowPopup(modal)) popupQueue.push(modal);
    runPopupQueue();
  }, delay);
});

const loadMetalMarket = async (market) => {
  const baseUrl = market.dataset.providerUrl.replace(/\/$/, '');
  const priceNodes = {
    XAU: market.querySelector('[data-metal-price="XAU"]'),
    XAG: market.querySelector('[data-metal-price="XAG"]')
  };
  const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
  try {
    const responses = await Promise.all(['XAU', 'XAG'].map((symbol) => fetch(`${baseUrl}/${symbol}`, { headers: { Accept: 'application/json' } })));
    if (responses.some((response) => !response.ok)) throw new Error('Market data unavailable');
    const quotes = await Promise.all(responses.map((response) => response.json()));
    quotes.forEach((quote) => {
      if (priceNodes[quote.symbol] && Number.isFinite(Number(quote.price))) priceNodes[quote.symbol].textContent = formatter.format(Number(quote.price));
    });
    const status = market.querySelector('[data-metal-status]');
    if (status) status.textContent = `Indicative USD spot · updated ${quotes[0]?.updatedAtReadable || 'now'}`;
  } catch (_) {
    if (priceNodes.XAU) priceNodes.XAU.textContent = market.dataset.goldFallback;
    if (priceNodes.XAG) priceNodes.XAG.textContent = market.dataset.silverFallback;
  }
};

document.querySelectorAll('[data-live-metal-market]').forEach((market) => {
  loadMetalMarket(market);
  const interval = Math.max(5, Number(market.dataset.refreshMinutes || 5)) * 60000;
  setInterval(() => loadMetalMarket(market), interval);
});
